import { fileProblem, FILE_MESSAGES, UNKNOWN_FILE_TYPE, type AttachedFile, type AttachmentSettings } from './files';

interface ProcessFilesProps {
  chosen: Iterable<File>;
  settings: AttachmentSettings;
  max: number | undefined;
  room: number;
  attachFile(file: File): string;
}

export const processFiles = ({ chosen, settings, max, room, attachFile }: ProcessFilesProps) => {
  const added: AttachedFile[] = [];
  const notAttached: string[] = [];
  for (const file of chosen) {
    const full = max !== undefined && added.length >= room;
    const problem = fileProblem(settings, file) ?? (full ? FILE_MESSAGES.tooMany(max) : undefined);
    if (problem !== undefined) notAttached.push(FILE_MESSAGES.notAttached(file.name, problem));
    else {
      const mimeType = file.type || UNKNOWN_FILE_TYPE;
      added.push({ fileId: attachFile(file), name: file.name, size: file.size, mimeType });
    }
  }
  return { added, notAttached };
};
